
const AddPageIcon = () => {
    return <svg
        xmlns="http://www.w3.org/2000/svg"
        width="15.9"
        height="19.5"
        viewBox="0 0 15.9 19.5"
    >
        <g id="file-plus" transform="translate(-3.25 -1.25)">
            <path
                id="Path_372"
                data-name="Path 372"
                d="M13,2H5.8A1.8,1.8,0,0,0,4,3.8V18.2A1.805,1.805,0,0,0,5.8,20H16.6a1.8,1.8,0,0,0,1.8-1.8V7.4Z"
                fill="none"
                stroke="#0c3254"
                strokeLinecap="square"
                strokeWidth="1.5"
            />
            <path
                id="Path_373"
                data-name="Path 373"
                d="M14,3V8h5m-6,9V11m-3,3h6"
                transform="translate(-1.6)"
                fill="none"
                stroke="#0c3254"
                strokeLinecap="square"
                strokeWidth="1.5"
            />
        </g>
    </svg>
}

export default AddPageIcon;